import ImageDropzone from "../../../../../../component/ImageDropZone";
import { usePosterContext } from "../../../../context/poster-context";
import { EditLine } from "../../styles";
import {
  MainInfoSectionItem,
  MainInfoWrapper,
} from "../main-info/styles/main-info.style";
import {
  ImageDropzoneWrapper,
  ImageItemRow,
  ImageWrapper,
  ImageDropInitialContent,
  DeleteButton,
} from "./styles/image.style";

const Image = () => {
  const {
    image1,
    setImage1,
    image2,
    setImage2,
    topPadding,
    setTopPadding,
    rightPadding,
    setRightPadding,
  } = usePosterContext();
  return (
    <MainInfoWrapper>
      <ImageWrapper>
        <ImageItemRow>
          <span className="title">좌측 이미지</span>
          <ImageDropzoneWrapper>
            {image2 && (
              <DeleteButton
                src="/image-web/poster/delete.svg"
                alt="delete"
                onClick={() => setImage2("")}
              />
            )}
            <ImageDropzone
              onImageUpload={(file) => {
                setImage2(URL.createObjectURL(file));
              }}
              minHeight={100}
              minWidth={100}
              maxHeight={1800}
              maxWidth={1800}
              defaultUrl={image2}
            >
              <ImageDropInitialContent>
                <img src="/image-web/icon/image.svg" alt="Initial content" />
                <h3>이미지를 올려주세요!</h3>
                <p>1:1 비율의 이미지를 권장합니다.</p>
              </ImageDropInitialContent>
            </ImageDropzone>
          </ImageDropzoneWrapper>
        </ImageItemRow>
        <ImageItemRow>
          <span className="title">우측 이미지</span>
          <ImageDropzoneWrapper>
            {image1 && (
              <DeleteButton
                src="/image-web/poster/delete.svg"
                alt="delete"
                onClick={() => setImage1("")}
              />
            )}
            <ImageDropzone
              onImageUpload={(file) => {
                setImage1(URL.createObjectURL(file));
              }}
              defaultUrl={image1}
              minHeight={100}
              minWidth={100}
              maxHeight={1800}
              maxWidth={1800}
            >
              <ImageDropInitialContent>
                <img src="/image-web/icon/image.svg" alt="Initial content" />
                <h3>이미지를 올려주세요!</h3>
                <p>1:1 비율의 이미지를 권장합니다.</p>
              </ImageDropInitialContent>
            </ImageDropzone>
          </ImageDropzoneWrapper>
        </ImageItemRow>
      </ImageWrapper>
      <EditLine style={{ marginBottom: "30px" }} />
      <MainInfoSectionItem style={{ marginBottom: "10px" }}>
        <div className="padding-label">상단 여백</div>
        <img
          src="/image-web/poster/minus.svg"
          alt="minus"
          onClick={() => {
            if (topPadding > 1) {
              setTopPadding(topPadding - 1);
            }
          }}
        />
        <div className="font-size">{topPadding}</div>
        <img
          src="/image-web/poster/plus.svg"
          alt="plus"
          onClick={() => {
            setTopPadding(topPadding + 1);
          }}
        />
      </MainInfoSectionItem>
      <MainInfoSectionItem>
        <div className="padding-label">오른쪽 여백</div>
        <img
          src="/image-web/poster/minus.svg"
          alt="minus"
          onClick={() => {
            if (rightPadding > 1) {
              setRightPadding(rightPadding - 1);
            }
          }}
        />
        <div className="font-size">{rightPadding}</div>
        <img
          src="/image-web/poster/plus.svg"
          alt="plus"
          onClick={() => {
            setRightPadding(rightPadding + 1);
          }}
        />
      </MainInfoSectionItem>
    </MainInfoWrapper>
  );
};

export default Image;
